import { render, staticRenderFns } from "./ViewInvoicesData.vue?vue&type=template&id=2f275fab&scoped=true&"
import script from "./ViewInvoicesData.vue?vue&type=script&lang=ts&"
export * from "./ViewInvoicesData.vue?vue&type=script&lang=ts&"
import style0 from "./ViewInvoicesData.vue?vue&type=style&index=0&id=2f275fab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f275fab",
  null
  
)

export default component.exports